<template>
  <div class="togglelabel" v-bind:class="{ 'isOpen': open, 'isToggleable': toggleable }">

    <div class="attributes__title"
      v-if="toggleable === false"
    >{{ title }}</div>

    <div class="attributes__title attributes__title--toggleable"
      v-if="toggleable === true"
      @click="toggleOpen()"
    >
      <div class="label label--none"
        v-if="selected === false"
      >Choose {{ title.toLowerCase() }}</div>

      <div class="label label--selected"
        v-if="selected !== false"
      >{{ selected }}</div>

    </div><!-- /.attributes__title--toggleable -->

    <div v-if="toggleable" class="countries-nav__header__toggle" @click="toggleOpen()">
      <ToggleArrow :width="8" :closed="!open"></ToggleArrow>
    </div>

  </div><!-- /.togglelabel -->
</template>

<script>
import ToggleArrow from '../shared/ToggleArrow.vue'

export default {
  name: 'togglelabel',
  components: { ToggleArrow },
  props: {
    toggleable: {
      type: Boolean,
      default: false
    },
    closed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    selected: {
      default: false
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  watch: {
    closed () {
      this.open = !this.closed
    }
  },
  mounted () {
    this.open = !this.closed
  },
  methods: {
    toggleOpen () {
      this.open = !this.open
      this.callback(this.open)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .togglelabel{
    display: flex; -js-display: flex;
    flex-wrap: nowrap;
  }
  .togglelabel.isToggleable{
    background: $gray-lighter;
    &.isOpen{ background: transparent; }
  }

  .attributes{
    flex: 1 1 auto;
    padding: 20px;
    width: 100%;
  }

  // This should have same height as LeveLNavigation:
  // Padding-top: 20px, padding-bottom: 20px, font-size: 14px;
  .attributes__title{
    color: $gray-darkest;
    font: 100 19px/1 $fontfamily-serif;
    padding: 17.5px 10px 17.5px 20px;
  }

  .attributes__title--toggleable{ cursor: pointer }

  .countries-nav__header__toggle,
  .countries-nav__header__current,
  .countries-nav__header__notselected{ cursor: pointer; }

  .attributes__title--toggleable{ flex: 1 1 auto; }

  .countries-nav__header__toggle{
    padding: 20px 0px;
    width: 45px;
  }

  .label--selected{
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/shared/ToggleLabel.vue